import { render, staticRenderFns } from "./EditableContentField.vue?vue&type=template&id=70e60219&scoped=true&"
import script from "./EditableContentField.vue?vue&type=script&lang=js&"
export * from "./EditableContentField.vue?vue&type=script&lang=js&"
import style0 from "./EditableContentField.vue?vue&type=style&index=0&id=70e60219&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e60219",
  null
  
)

export default component.exports